import axios from 'axios'

import { OFFLINE_ALERT_MESSAGE, FORCE_INTERNET_CONNECTION } from '../constants'
import { getCookie } from './utils/utils'
import { handleAxiosError } from './httpErrorHandler'

const apiUrl = import.meta.env.VITE_API_BASE_URL

const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  // Manual X-XSRF-TOKEN below. Axios' built-in reader uses decodeURIComponent and
  // throws URIError on a leftover/malformed XSRF-TOKEN cookie — a refresh crush.
  withXSRFToken: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

axiosInstance.interceptors.request.use((config) => {
  const token = getCookie('XSRF-TOKEN')
  if (token) {
    config.headers['X-XSRF-TOKEN'] = token
  }

  // Check for the browser connection status
  if (!navigator.onLine && FORCE_INTERNET_CONNECTION === 'true') {
    return Promise.reject(new Error(OFFLINE_ALERT_MESSAGE))
  }
  return config
})

axiosInstance.interceptors.response.use((response) => response, handleAxiosError)

export default axiosInstance
